import * as React from "react"
import type { SVGProps } from "react"
const SvgAlertCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 22.88q-.4 0-.76-.15a2 2 0 0 1-.67-.42l-8.02-8.03q-.27-.3-.42-.66t-.15-.76a2 2 0 0 1 .57-1.43l8.03-8.02q.3-.3.66-.44t.76-.14a2 2 0 0 1 1.43.58l8.02 8.02q.3.28.44.65a2.2 2.2 0 0 1 0 1.54 2 2 0 0 1-.44.66l-8.02 8.03a2 2 0 0 1-.65.42q-.37.15-.78.15m0-2 8.03-8.02L12 4.83l-8.02 8.03zm0-7.02q.42 0 .71-.29a1 1 0 0 0 .29-.71v-4a1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.3 1 1 0 0 0-.71.3 1 1 0 0 0-.29.7v4q0 .44.29.72.29.3.71.29m0 3q.42 0 .71-.29a1 1 0 0 0 .29-.71 1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.3 1 1 0 0 0-.71.3 1 1 0 0 0-.29.7q0 .44.29.72.29.3.71.29" />
  </svg>
)
export default SvgAlertCircle
